/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ members: NonNullable<unknown>, used: NonNullable<unknown>, begun: NonNullable<unknown>, total: NonNullable<unknown> }} Partner_Edit_Contract_UsageInputs */



/**
* | output |
* | --- |
* | "{members} paid seats in use · {used} of the budget used · {begun} of {total} months begun" |
*
* @param {Partner_Edit_Contract_UsageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_edit_contract_usage = /** @type {((inputs: Partner_Edit_Contract_UsageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Edit_Contract_UsageInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.members} bezahlte Plätze belegt · ${i?.used} des Budgets verbraucht · ${i?.begun} von ${i?.total} Monaten begonnen`)
	return /** @type {LocalizedString} */ (`${i?.members} paid seats in use · ${i?.used} of the budget used · ${i?.begun} of ${i?.total} months begun`)
});